import React from "react";

// TODO: define default page
export const Page = ({ children }: { children: JSX.Element }) => <>{children}</>;
